import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';

export const Wrapper = styled.div`
  list-style: none;
  height: 100%;
  width: 100%;
  text-align: center;
`;

export const MotionDiv = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  margin: 0 auto;
  padding-bottom: 20px;
  max-width: 265px;
  height: auto;

  P {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    margin: 1rem;
  }

  h3 {
    font-size: 22px;
    line-height: 28px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 320px;
  }
`;

export const Body = styled.div`
  margin: 0 auto 2rem;
  max-width: 265px;
  p {
    font-size: 14px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 320px;
    padding: 5px;
    p {
      font-size: 16px;
    }
  }
`;

export const StyledImage = styled(Image)`
  width: 80%;
  margin: auto;
`;
